import { LaskunAsiakas, LaskunLahetystapa } from '@lemon/core-firebase/model/lasku'

export interface ToimitustavanNimet {
  verkkolasku: string
  sahkoposti: string
  itse: string
}

export function vertaaAsiakkaita(a: LaskunAsiakas, b: LaskunAsiakas, sarake: string): number {
  return annaLajitteluarvo(a, sarake).toLowerCase().localeCompare(annaLajitteluarvo(b, sarake).toLowerCase(), 'fi')
}

function annaLajitteluarvo(asiakas: LaskunAsiakas, sarake: string): string {
  switch (sarake) {
    case 'nimi':
      return asiakas.nimi ?? ''
    case 'ytunnus':
      return asiakas.ytunnus ?? ''
    case 'katuosoite':
      return asiakas.katuosoite ?? ''
    case 'postinro':
      return asiakas.postinro ?? ''
    case 'postitoimipaikka':
      return asiakas.postitmp ?? ''
    case 'maa':
      return asiakas.maa ?? ''
    default:
      return ''
  }
}

/** Asiakasrekisterin toimitussarake: verkkolaskulla välittäjä, sähköpostilla ensimmäinen vastaanottaja ja muiden määrä. */
export function annaToimitusteksti(asiakas: LaskunAsiakas, nimet: ToimitustavanNimet, valittajanNimi: string | null): string {
  switch (asiakas.oletusLahetystapa) {
    case LaskunLahetystapa.SAHKOINEN:
      return valittajanNimi ? `${nimet.verkkolasku} · ${valittajanNimi}` : nimet.verkkolasku
    case LaskunLahetystapa.SAHKOPOSTI: {
      const [ensimmainen, ...muut] = asiakas.laskunVastaanottajat ?? []
      if (!ensimmainen) {
        return nimet.sahkoposti
      }
      return muut.length ? `${ensimmainen} +${muut.length}` : ensimmainen
    }
    case LaskunLahetystapa.ITSE:
      return nimet.itse
    default:
      return '–'
  }
}
